"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FolderImage: function() {
        return FolderImage;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FolderImage = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H5.55606L11.2947 13.2911C11.6645 12.9232 12.2548 12.9013 12.6508 13.2407L13.5693 14.028L17.2918 10.294C17.6639 9.92072 18.2619 9.90035 18.6585 10.2474L21 12.2962V8C21 7.44772 20.5523 7 20 7H12.6056C12.0133 7 11.4343 6.82469 10.9415 6.49615L8.94915 5.16795C8.78488 5.05844 8.59187 5 8.39445 5H4ZM21 14.9538L18.0467 12.3696L15.0921 15.3333L19.3699 19H20C20.5523 19 21 18.5523 21 18V14.9538ZM16.2967 19L12.9719 16.1501L12.0505 15.3603L8.39186 19H16.2967ZM1 6C1 4.34315 2.34315 3 4 3H8.39445C8.98672 3 9.56575 3.17531 10.0585 3.50385L12.0509 4.83205C12.2151 4.94156 12.4081 5 12.6056 5H20C21.6569 5 23 6.34315 23 8V14.5V18C23 19.6569 21.6569 21 20 21H19H5.96875H4C2.34315 21 1 19.6569 1 18V6ZM7.96875 8.97656C7.41647 8.97656 6.96875 9.42428 6.96875 9.97656C6.96875 10.5288 7.41647 10.9766 7.96875 10.9766C8.52103 10.9766 8.96875 10.5288 8.96875 9.97656C8.96875 9.42428 8.52103 8.97656 7.96875 8.97656ZM4.96875 9.97656C4.96875 8.31971 6.3119 6.97656 7.96875 6.97656C9.6256 6.97656 10.9688 8.31971 10.9688 9.97656C10.9688 11.6334 9.6256 12.9766 7.96875 12.9766C6.3119 12.9766 4.96875 11.6334 4.96875 9.97656Z",
        fill: "currentColor"
    })
}), "FolderImage");
const _default = FolderImage;
